import { useState } from "react";
import API from "../services/api";

export default function NotificationHistory() {
  const [studentId, setStudentId] = useState("");
  const [notifications, setNotifications] = useState([]);

  const fetchNotifications = async () => {
    try {
      const res = await API.get(`/notifications/${studentId}`);
      setNotifications(res.data);
    } catch (err) {
      alert("Unable to fetch notification history");
    }
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6">
        Notification History
      </h1>

      <div className="bg-white shadow p-6 rounded mb-6">
        <input
          placeholder="Enter Student ID"
          value={studentId}
          onChange={(e) => setStudentId(e.target.value)}
          className="border p-2 w-full mb-4"
        />

        <button
          onClick={fetchNotifications}
          className="bg-blue-600 text-white px-4 py-2 rounded"
        >
          View Notifications
        </button>
      </div>

      <div className="bg-white shadow p-6 rounded">
        <table className="w-full border">
          <thead>
            <tr className="bg-gray-100">
              <th>Type</th>
              <th>Message</th>
              <th>Sent At</th>
            </tr>
          </thead>

          <tbody>
            {notifications.map((item) => (
              <tr key={item.id}>
                <td>{item.type}</td>
                <td>{item.message}</td>
                <td>{item.sent_at}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}